import { CommonProps } from "@/components/forms/types";

/**
 * Lägger till eller tar bort required i validation för att undvika dubletter
 * @param shouldBeRequired Värdet som kommer från inställningar
 * @param validation Validation som skickats in i input
 */
export const modifyRequiredValidation: (props: {
    shouldBeRequired: boolean;
    validation?: CommonProps["validation"];
}) => CommonProps["validation"] | undefined = ({ shouldBeRequired, validation }) => {
    // Om validation inte är satt och det ska vara required
    if (!validation && shouldBeRequired) {
        return "required";
    } else if (typeof validation === "string") {
        const hasRequired = validation.match(/(^required|\|required\||\|required$)/g);

        // Om det ska vara required och inte har det satt
        if (shouldBeRequired && !hasRequired) {
            return `${validation}|required`;
            // Om det inte ska vara required och har det satt
        } else if (shouldBeRequired !== null && !shouldBeRequired && hasRequired) {
            // Tar bort required
            return validation.replace(/(^\|required\||\|required|required\||required|$)/g, "");
        }

        return validation;
    } else if (validation && Array.isArray(validation)) {
        const requiredIndex = validation.findIndex(([rule]) => rule === "required");

        // Om det ska vara required och inte har det satt
        if (shouldBeRequired && requiredIndex === -1) {
            return [...validation, ["required"]];
            // Om det inte ska vara required och har det satt
        } else if (shouldBeRequired !== null && !shouldBeRequired && requiredIndex >= 0) {
            const modified = [...validation];

            // Tar bort required
            modified.splice(requiredIndex, 1);

            return modified;
        }

        return validation;
    }

    return validation;
};

export const getRequiredValidation = ({ validation }: { validation?: CommonProps["validation"] }) => {
    if (typeof validation === "string") {
        return validation.includes("required");
    }

    if (Array.isArray(validation)) {
        return !!validation.find(([rule]) => rule === "required");
    }

    return false;
};
